export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'faq', getter: () => import(/* webpackChunkName: "expandableTextList" */ 'components/bolt/expandableTextList/expandableTextList'), component: 'expandableTextList' },
	{ id: 'memeGenerator', getter: () => import(/* webpackChunkName: "memeGenerator" */ 'components/bolt/memeGenerator/memeGenerator'), component: 'memeGenerator' },
	{ id: 'participatingTerritories', getter: () => import(/* webpackChunkName: "text" */ 'components/bolt/text/text'), component: 'text' },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "watchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
